module.exports = __webpack_public_path__ + "static/media/icon_color.820fe2e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/icon_color.svg
// module id = 690
// module chunks = 0